import React from 'react';
import './StatusNotice.css';

const DEFAULT_ICONS = {
  success: '✓',
  info: 'i',
  warning: '!',
  accent: 'i',
  danger: '!',
};

/**
 * Shared status notice — visual language matches transfer submit-success banners.
 * Variants: success | info | warning | accent | danger
 */
function StatusNotice({
  variant = 'info',
  icon,
  plainIcon = false,
  title,
  children,
  meta,
  actions,
  onDismiss,
  dismissLabel = 'Dismiss',
  className = '',
  role = 'status',
}) {
  const resolvedIcon = icon ?? DEFAULT_ICONS[variant] ?? 'i';
  const liveRole = role === 'status' && variant === 'danger' ? 'alert' : role;

  return (
    <div
      className={`status-notice status-notice--${variant}${className ? ` ${className}` : ''}`}
      role={liveRole}
    >
      <div className="status-notice-banner">
        <span
          className={`status-notice-icon${plainIcon ? ' status-notice-icon--plain' : ''}`}
          aria-hidden="true"
        >
          {resolvedIcon}
        </span>
        <div className="status-notice-body">
          {title ? <div className="status-notice-title">{title}</div> : null}
          {children ? <div className="status-notice-text">{children}</div> : null}
          {meta ? <div className="status-notice-meta">{meta}</div> : null}
          {actions ? <div className="status-notice-actions">{actions}</div> : null}
        </div>
        {onDismiss ? (
          <button
            type="button"
            className="status-notice-dismiss"
            onClick={onDismiss}
            title={dismissLabel}
            aria-label={dismissLabel}
          >
            ✕
          </button>
        ) : null}
      </div>
    </div>
  );
}

export default StatusNotice;
